var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdicionarPaci(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 16.9844V15.0156H12.9844V10.9844H11.0156V15.0156H6.98438V16.9844H11.0156V21.0156H12.9844V16.9844H17.0156ZM4.92188 8.96875C6.89062 7 9.25 6.01562 12 6.01562C14.75 6.01562 17.0938 7 19.0312 8.96875C21 10.9062 21.9844 13.25 21.9844 16C21.9844 18.75 21 21.1094 19.0312 23.0781C17.0938 25.0156 14.75 25.9844 12 25.9844C9.25 25.9844 6.89062 25.0156 4.92188 23.0781C2.98438 21.1094 2.01562 18.75 2.01562 16C2.01562 13.25 2.98438 10.9062 4.92188 8.96875Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdicionarPaci);
export default __webpack_public_path__ + "static/media/adicionar_paci.f7d81c7583471513dcd2d8abc7332279.svg";
export { ForwardRef as ReactComponent };